// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3yZcP","content":"Consent_content__lqsoz","footer":"Consent_footer__34Uil"};